export default "__VITE_ASSET__C0L2jaBE__"